@if (show) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="p-2 errorDialog">
        <div class="flex-grow">
          {{error}}
        </div>
        <clear-button (click)="show = false" text="Exit" />
      </div>
    </div>
  </div>
}
